import { IconFigmaSearch } from '@/assets/icons';

import type { TextFieldProps } from './TextField';
import { TextField } from './TextField';

export const SearchField = (props: Omit<TextFieldProps, 'leftSection'>) => (
  <TextField
    leftSection={<IconFigmaSearch size={16} color="var(--color-text-secondary)" />}
    {...props}
  />
);
